
import { defaultHttpResponse, HttpResponse } from "../auth/AuthInterface";
import { ParteProps } from "./ParteInterface";

// Definición de defaults

export const defaultAmparo: AmparoProps = { 
    idAmparo: 0, 
    numeroAmparo: '', 
    numeroAmparoOrigen: '', 
    numeroExpediente: '', 
    idTipoAmparo: 0, 
    tipoAmparo: '', 
    idAutoridadAmparo: 0, 
    autoridadAmparo: '', 
    idEstatus: 0, 
    estatus: '',
    idJuez: 0,
    juez: '',
    idSecretario: 0,
    secretario: '',
    idJuzgadoOrigen: 0,
    juzgadoOrigen: '',
    digitalizacion: '',
    partes: [], 
    caratula: '',
};

export const defaultBuscarAmparo: BuscarAmparoResponse = {
    ...defaultHttpResponse,
    ...defaultAmparo,
};

export const defaultGenerarCaratulaAmparo: GenerarCaratulaAmparoResponse = {
    ...defaultHttpResponse,
    caratula: '',
};

// Creación de interfaces

export interface AmparoProps {
    idAmparo:               number;
    numeroAmparo:           string;
    numeroAmparoOrigen:     string;
    numeroExpediente:       string;
    idTipoAmparo:           number;
    tipoAmparo:             string;
    idAutoridadAmparo:      number;
    autoridadAmparo:        string;
    idEstatus:              number;
    estatus:                string;
    fecha?:                 Date;   
    idJuez:                 number;
    juez:                   string;
    idSecretario:           number;
    secretario:             string;
    idJuzgadoOrigen:        number;
    juzgadoOrigen:          string;
    digitalizacion:         string;
    partes:                 ParteProps[];
    caratula:               string;
}

export interface BuscarAmparoParams {
    idAutoridad:            number;
    numeroAmparo:           string;
    numeroAmparoOrigen:     string;
    numeroExpediente:       string;
}

export interface BuscarAmparoResponse extends HttpResponse, AmparoProps { }

export interface EditarAmparoParams {
    idAmparo:           number;
    numeroAmparoOrigen: string;
    idTipoAmparo:       number;
    idAutoridadAmparo:  number;
}

export interface AgregarPartesAmparoParams {
    idAmparo:   number;
    partes:     ParteProps[];
}

export interface AsignarExpedienteAmparoParams {
    idAmparo:       number;
    idExpediente:   number;
    idAcuerdo?:     number;
}

export interface PartesAmparoProps {
    parte: string;
    tipoParte: string;
}

export interface GenerarCaratulaAmparoResponse {
    success:        boolean;
    message:        string;
    caratula:       string;
}